// Centralized project data management
export const projectsData = {
  'cricket': {
    id: 'cricket',
    title: 'Cricket Coverage',
    category: 'Sports',
    image: '/Cricket/27c4d6ff-75ed-4e5d-9d53-068461af40f2.JPG',
    description: 'Professional cricket coverage featuring high-quality video production and live streaming for major cricket events.',
    longDescription: 'Digital Shark Inc provided comprehensive cricket coverage for major tournaments and matches, showcasing our expertise in sports broadcasting. Our team captured every moment with precision, from the opening ceremonies to the final celebrations.',
    services: ['Live Sports Coverage', 'Multi-Camera Setup', 'Highlights Production', 'Live Streaming', 'Post-Production', 'Color Grading'],
    date: '2024',
    location: 'Barbados',
    channels: ['YouTube', 'ESPN+', 'Local Networks', 'Social Media'],
    credits: 'Digital Shark Inc Sports Division',
    stats: {
      viewers: '25,000+',
      countries: '10+',
      platforms: '4',
      duration: '48 hours'
    },
    gallery: [
      '/Cricket/27c4d6ff-75ed-4e5d-9d53-068461af40f2.JPG',
      '/Cricket/4baf1da0-8b55-4ca5-ab88-fb689735cf16.JPG',
      '/Cricket/5887c0bc-eae6-440c-9a20-6771dc6b300f.JPG',
      '/Cricket/77484993-4698-4e0a-8a63-e801c4e9a6b3.JPG',
      '/Cricket/962cdce9-3d3f-4470-b669-1cf9520d1e07.JPG'
    ]
  },
  'carifta-swimming': {
    id: 'carifta-swimming',
    title: 'CARIFTA Swimming Championships',
    category: 'Sports',
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=800&h=500&fit=crop',
    description: 'Comprehensive coverage of the CARIFTA Swimming Championships with underwater and above-water camera work.',
    longDescription: 'The CARIFTA Swimming Championships showcase the best young swimmers from across the Caribbean. Our coverage includes both underwater and above-water perspectives to capture every stroke and turn.',
    services: ['Underwater Coverage', 'Multi-Camera Setup', 'Live Streaming', 'Highlights Production', 'Slow Motion', 'Technical Analysis'],
    date: '2024',
    location: 'Barbados',
    channels: ['YouTube', 'CARIFTA Network', 'Social Media', 'Local TV'],
    credits: 'DigitalShark Sports Division',
    stats: {
      viewers: '20,000+',
      countries: '15+',
      platforms: '4',
      duration: '36 hours'
    },
    gallery: [
      '/Carifta Swimming/CARIFTA swimming no voice over (stations).mp4'
    ]
  },
  'barbados-cricket-legends': {
    id: 'barbados-cricket-legends',
    title: 'Barbados: Home of Cricket Legends',
    category: 'Documentary',
    image: '/Barbados Home of Cricket Legends/WhatsApp Image 2025-10-26 at 7.38.36 PM.jpeg',
    description: 'Selected by the National Cultural Foundation to produce this landmark biographical documentary celebrating Barbados\' legendary contribution to world cricket.',
    longDescription: 'A comprehensive biographical documentary that chronicles Barbados\' extraordinary contribution to world cricket. This landmark production showcases the island\'s rich cricketing heritage and legendary players who have shaped the sport globally.',
    services: ['Documentary Production', 'Biographical Research', 'Historical Footage', 'Post-Production', 'Color Grading', 'Sound Design'],
    date: '2024',
    location: 'Barbados',
    channels: ['National Cultural Foundation', 'Local TV', 'Documentary Networks', 'Streaming Platforms'],
      credits: 'Digital Shark Inc Documentary Division',
    stats: {
      viewers: '50,000+',
      countries: '20+',
      platforms: '6',
      duration: '90 minutes'
    },
    gallery: [
      '/Barbados Home of Cricket Legends/WhatsApp Image 2025-10-26 at 7.38.36 PM.jpeg',
      '/Barbados Home of Cricket Legends/WhatsApp Image 2025-09-24 at 6.10.44 PM.jpeg'
    ]
  },
  'emancipation-cup-2024': {
    id: 'emancipation-cup-2024',
    title: 'Emancipation Cup 2024 – St. Vincent and the Grenadines',
    category: 'Sports',
    image: 'https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=800&h=500&fit=crop',
    description: 'Live broadcast and global streaming of this historic cricket tournament.',
    longDescription: 'Historic cricket tournament coverage featuring live broadcast and global streaming capabilities. This prestigious event brought together top cricketing talent in a celebration of Caribbean cricket heritage.',
    services: ['Live Broadcasting', 'Global Streaming', 'Multi-Camera Setup', 'Commentary', 'Highlights Production', 'Social Media Integration'],
    date: '2024',
    location: 'St. Vincent and the Grenadines',
    channels: ['Global Streaming', 'Local TV', 'Sports Networks', 'Social Media'],
    credits: 'DigitalShark Sports Division',
    stats: {
      viewers: '100,000+',
      countries: '25+',
      platforms: '8',
      duration: '72 hours'
    },
    gallery: [
      'https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=800&h=500&fit=crop'
    ]
  },
  'barbados-road-tennis-2025': {
    id: 'barbados-road-tennis-2025',
    title: 'Barbados Road Tennis Open 2025',
    category: 'Sports',
    image: '/Barbados Road Tennis Open 2025/WhatsApp Image 2025-09-24 at 6.02.58 PM.jpeg',
    description: 'Covered and distributed Barbados\'s indigenous sporting event, bringing road tennis to a wider international audience.',
    longDescription: 'Barbados\' unique indigenous sport brought to the world stage through comprehensive coverage and international distribution. This event showcased the island\'s cultural sporting heritage to a global audience.',
    services: ['Event Coverage', 'International Distribution', 'Cultural Documentation', 'Multi-Camera Production', 'Post-Production', 'Global Streaming'],
    date: '2025',
    location: 'Barbados',
    channels: ['International Sports Networks', 'Cultural Platforms', 'Streaming Services', 'Social Media'],
      credits: 'Digital Shark Inc Cultural Division',
    stats: {
      viewers: '75,000+',
      countries: '30+',
      platforms: '10',
      duration: '48 hours'
    },
    gallery: [
      '/Barbados Road Tennis Open 2025/WhatsApp Image 2025-09-24 at 6.02.58 PM.jpeg',
      '/Barbados Road Tennis Open 2025/WhatsApp Image 2025-09-24 at 6.15.34 PM.jpeg'
    ]
  },
  'barbados-ninja-warrior-2025': {
    id: 'barbados-ninja-warrior-2025',
    title: 'Barbados Ninja Warrior 2025',
    category: 'Sports',
    image: '/Barbados Ninja Warrior 2025/WhatsApp Image 2025-09-24 at 6.09.48 PM.jpeg',
    description: 'Produced and streamed the highly anticipated national competition showcasing athleticism and entertainment.',
    longDescription: 'High-energy athletic competition featuring obstacle course challenges and entertainment elements. This national competition brought together top athletes in a thrilling display of strength, agility, and determination.',
    services: ['Live Production', 'Multi-Camera Coverage', 'Entertainment Integration', 'Athletic Documentation', 'Streaming', 'Highlights'],
    date: '2025',
    location: 'Barbados',
    channels: ['National TV', 'Streaming Platforms', 'Sports Networks', 'Social Media'],
      credits: 'Digital Shark Inc Entertainment Division',
    stats: {
      viewers: '40,000+',
      countries: '15+',
      platforms: '6',
      duration: '24 hours'
    },
    gallery: [
      '/Barbados Ninja Warrior 2025/WhatsApp Image 2025-09-24 at 6.09.48 PM.jpeg'
    ]
  },
  'ifbb-world-cup-2025': {
    id: 'ifbb-world-cup-2025',
    title: 'IFBB World Cup 2025– Barbados',
    category: 'Sports',
    image: '/IFBB World Cup 2025– Barbados/WhatsApp Image 2025-10-16 at 10.29.54 AM.jpeg',
    description: 'Delivered high-quality coverage and streaming for one of the world\'s top bodybuilding competitions.',
    longDescription: 'World-class bodybuilding competition featuring elite athletes from around the globe. This prestigious IFBB event showcased the pinnacle of physique competition with professional coverage and global streaming.',
    services: ['Professional Coverage', 'Global Streaming', 'Multi-Camera Setup', 'Judging Documentation', 'Athlete Profiles', 'Post-Production'],
    date: '2025',
    location: 'Barbados',
    channels: ['IFBB Network', 'Global Streaming', 'Sports Networks', 'Fitness Platforms'],
    credits: 'Digital Shark Inc Sports Division',
    stats: {
      viewers: '200,000+',
      countries: '50+',
      platforms: '12',
      duration: '96 hours'
    },
    gallery: [
      '/IFBB World Cup 2025– Barbados/WhatsApp Image 2025-10-16 at 10.29.54 AM.jpeg',
      '/IFBB World Cup 2025– Barbados/WhatsApp Image 2025-09-24 at 6.12.13 PM.jpeg'
    ]
  },
  'cpl-beach-blast-2025': {
    id: 'cpl-beach-blast-2025',
    title: 'CPL Beach Blast 2025',
    category: 'Sports',
    image: '/CPL Beach Blast/WhatsApp Image 2025-09-24 at 6.05.12 PM.jpeg',
    description: 'Coverage and streaming of the Caribbean Premier League Beach Blast cricket tournament with dynamic production for a global audience.',
    longDescription: 'The Caribbean Premier League Beach Blast brought the excitement of T20 cricket to the beach with a unique format that captivated audiences worldwide. Our dynamic production captured every thrilling moment of this innovative tournament, showcasing the best of Caribbean cricket talent in a spectacular beach setting.',
    services: ['Live Broadcast', 'Global Streaming', 'Dynamic Production', 'Multi-Camera Coverage', 'Beach-Specific Setup', 'Real-Time Commentary', 'Highlights Production', 'Social Media Integration'],
    date: '2025',
    location: 'Caribbean',
    channels: ['CPL Network', 'Global Streaming', 'Sports Networks', 'Social Media', 'International Broadcasters'],
    credits: 'DigitalShark Sports Division',
    stats: {
      viewers: '150,000+',
      countries: '35+',
      platforms: '10',
      duration: '48 hours'
    },
    gallery: [
      '/CPL Beach Blast/WhatsApp Image 2025-09-24 at 6.05.12 PM.jpeg',
      '/CPL Beach Blast/WhatsApp Image 2025-09-24 at 6.05.12 PM (1).jpeg',
      '/CPL Beach Blast/WhatsApp Image 2025-09-24 at 6.05.12 PM (2).jpeg'
    ]
  }
};

// Helper function to get all projects
export const getAllProjects = () => Object.values(projectsData);

// Helper function to get project by ID
export const getProjectById = (id) => projectsData[id];

// Helper function to get projects by category
export const getProjectsByCategory = (category) => 
  Object.values(projectsData).filter(project => project.category === category);

// Helper function to get related projects
export const getRelatedProjects = (currentProjectId, limit = 3) => 
  Object.values(projectsData)
    .filter(project => project.id !== currentProjectId)
    .slice(0, limit);

// Helper function to get featured projects for home page
export const getFeaturedProjects = (limit = 3) => 
  Object.values(projectsData).slice(0, limit);

// Helper function to add media to project gallery
export const addMediaToProject = (projectId, mediaPath) => {
  if (projectsData[projectId]) {
    if (!projectsData[projectId].gallery) {
      projectsData[projectId].gallery = [];
    }
    projectsData[projectId].gallery.push(mediaPath);
  }
};

// Helper function to check if file is video
export const isVideoFile = (filename) => {
  const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v'];
  return videoExtensions.some(ext => filename.toLowerCase().endsWith(ext));
};

// Helper function to check if file is image
export const isImageFile = (filename) => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
  return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
};

// Clients and Partners data
export const clientsPartners = [
  {
    name: 'Caribbean Football Union',
    category: 'Sports Federation',
    logo: '/logos/cfu-logo.png',
    description: 'Regional football federation partnership'
  },
  {
    name: 'Trinidad & Tobago Cycling Federation',
    category: 'Sports Federation',
    logo: '/logos/ttcf-logo.png',
    description: 'Cycling event coverage and distribution'
  },
  {
    name: 'Nation TV Barbados',
    category: 'Broadcaster',
    logo: '/logos/nation-tv-logo.png',
    description: 'Local television network partnership'
  },
  {
    name: 'Caribbean Broadcasting Corporation',
    category: 'Broadcaster',
    logo: '/logos/cbc-logo.png',
    description: 'Regional broadcasting partnership'
  },
  {
    name: 'National Cultural Foundation',
    category: 'Cultural Institution',
    logo: '/logos/ncf-logo.png',
    description: 'Cultural content production and distribution'
  },
  {
    name: 'IFBB World Cup',
    category: 'International Event',
    logo: '/logos/ifbb-logo.png',
    description: 'International bodybuilding competition coverage'
  },
  {
    name: 'CPL Beach Blast',
    category: 'Sports League',
    logo: '/logos/cpl-logo.png',
    description: 'Caribbean Premier League cricket coverage'
  },
  {
    name: 'CARIFTA Swimming',
    category: 'Sports Federation',
    logo: '/logos/carifta-logo.png',
    description: 'Regional swimming championship coverage'
  }
];
